import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getExtAdminFeedbacks } from "../../../redux/actions/profile";

const PRIMARY = "#a7cc48";
const BG = "#2c2d3f";

export default function ExtFeedbacks() {
  const dispatch = useDispatch();
  const feedbacks = useSelector((s) => s.profile.extAdminFeedbacks);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(getExtAdminFeedbacks());
  }, [dispatch]);

  const allFeedbacks = feedbacks || [];
  const filtered = allFeedbacks.filter((f) => {
    const q = search.toLowerCase();
    return !q || [f.report, f.location, f.reporter?.fullName, f.reporter?.email].some((v) => v && v.toLowerCase().includes(q));
  });

  return (
    <div>
      <div style={styles.header}>
        <div>
          <h2 style={styles.heading}>Agent Feedbacks</h2>
          <p style={styles.subText}>Field reports submitted by agents under your management.</p>
        </div>
      </div>

      <div style={styles.searchBox}>
        <i className="bi bi-search" style={{ color: "#bbb", marginRight: 8 }} />
        <input style={styles.searchInput} placeholder="Search feedbacks…" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      {filtered.length === 0 ? (
        <div style={styles.empty}>
          <i className="bi bi-chat-left-text" style={{ fontSize: 40, color: "#ccc" }} />
          <p style={{ marginTop: 12, color: "#888" }}>No feedbacks yet.</p>
        </div>
      ) : (
        <div style={styles.list}>
          {filtered.map((f) => (
            <div key={f._id} style={styles.card}>
              <div style={styles.cardMeta}>
                <span style={styles.agentName}>
                  <i className="bi bi-person-fill" style={{ color: PRIMARY, marginRight: 5 }} />
                  {f.reporter?.fullName || f.reporter?.email || "Unknown Agent"}
                </span>
                <span style={styles.sector}>Sector {f.sector}</span>
                <span style={styles.date}>{f.date ? new Date(f.date).toLocaleDateString() : "—"}</span>
              </div>
              {f.location && (
                <div style={styles.location}>
                  <i className="bi bi-geo-alt-fill" style={{ color: "#888", marginRight: 4, fontSize: 11 }} />
                  {f.location}
                </div>
              )}
              <p style={styles.report}>{f.report}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  header: { marginBottom: 16 },
  heading: { fontSize: 22, fontWeight: 700, color: BG, marginBottom: 4 },
  subText: { color: "#888", fontSize: 13 },
  searchBox: { display: "flex", alignItems: "center", background: "#fff", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 14px", marginBottom: 20 },
  searchInput: { border: "none", outline: "none", fontSize: 14, flex: 1, background: "transparent" },
  list: { display: "flex", flexDirection: "column", gap: 14 },
  card: { background: "#fff", borderRadius: 10, padding: "18px 20px", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", borderLeft: "4px solid " + PRIMARY },
  cardMeta: { display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 6 },
  agentName: { fontWeight: 600, fontSize: 14, color: BG },
  sector: { background: "rgba(167,204,72,0.12)", color: "#5a8a00", borderRadius: 20, padding: "1px 10px", fontSize: 11, fontWeight: 600 },
  date: { color: "#aaa", fontSize: 12, marginLeft: "auto" },
  location: { color: "#888", fontSize: 12, marginBottom: 8 },
  report: { color: "#444", fontSize: 14, margin: 0, lineHeight: 1.6 },
  empty: { textAlign: "center", padding: 60, background: "#fff", borderRadius: 10 },
};
